var _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDatabaseRefresh = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Database_Refresh_20",
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.67 0 0 0.67 10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -5.25)",
    d: "M 12 9.751 C 5.787 9.751 0.75 7.736 0.75 5.251 C 0.75 2.766000000000001 5.787 0.751 12 0.751 C 18.213 0.751 23.25 2.7649999999999997 23.25 5.251 C 23.25 6.432 22.112000000000002 7.507 20.25 8.31",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.25 -5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23.25, -6.75)",
    d: "M 23.25 8.251 L 23.25 5.251",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.47 -1.62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-4.53, -10.38)",
    d: "M 0.75 5.251 L 0.75 11.251000000000001 C 0.75 13.217 3.9 14.888 8.3 15.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.83 4.45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.17, -16.45)",
    d: "M 0.75 11.251 L 0.75 17.250999999999998 C 0.75 19.406 4.538 21.206999999999997 9.596 21.650999999999996",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.38 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21.38, -13.5)",
    d: "M 19.5 15.751 L 23.25 15.751 L 23.25 11.251",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.16 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#EF5366",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-17.16, -17.25)",
    d: "M 23.061 15.751 C 22.36590836379707 13.055896327643739 19.908620358320057 11.192655205635962 17.12593032753278 11.25072740229306 C 14.343240296745506 11.30879959895016 11.965826171847032 13.272936533925732 11.383779452205886 15.994692916047843 C 10.801732732564739 18.716449298169955 12.167887074917122 21.481147135814016 14.683442001786041 22.672247298425447 C 17.19899692865496 23.863347461036874 20.203418765988996 23.168091217661523 21.94 20.993000000000002",
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDatabaseRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/databaseRefresh.1211c4c8.svg";
export { ForwardRef as ReactComponent };